import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid pt-4 pb-5",
  id: "Download"
}
const _hoisted_2 = { class: "row mt-5 d-flex flex-row justify-content-center align-items-center" }
const _hoisted_3 = { class: "inner col-12 col-lg-11 col-xl-10 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-flex flex-column flex-lg-row justify-content-center align-items-center top\"><p class=\"col-12 col-lg-3 mb-0 title\"><span class=\"number\">4. </span><span>Descarga datos</span></p><div class=\"col-12 col-lg-1 mt-2 mb-4 my-lg-0 d-flex justify-content-center align-items-center\"><div class=\"line\"></div></div><p class=\"col-11 col-lg-8 mb-0 text text-center text-lg-start\">En esta sección puedes descargar las fuentes de datos y la metodología para llevar a cabo las visualizaciones de información.</p></div>", 1)
const _hoisted_5 = { class: "row col-12 mt-5 d-flex flex-row justify-content-center align-items-center mid" }
const _hoisted_6 = { class: "modal-content pt-0 px-0" }
const _hoisted_7 = { class: "row two p-4 d-flex flex-column flex-lg-row justify-content-center justify-content-lg-around align-items-center" }
const _hoisted_8 = {
  class: "btn col-10 col-lg-5 p-3 my-2",
  href: "https://portalanterior.ine.mx/archivos2/s/DECEYEC/EducacionCivica/Documento_Principal_23Nov.pdf",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Descargar Informe País 2014", -1)
const _hoisted_10 = {
  class: "btn col-10 col-lg-5 p-3 my-2",
  href: "https://portalanterior.ine.mx/archivos2/portal/DECEYEC/EducacionCivica/informePais/"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Descargar Encuesta 2013", -1)
const _hoisted_12 = { class: "row three p-4 d-flex flex-lg-row flex-column justify-content-center justify-content-lg-around align-items-center" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Descargar Informe País 2020", -1)
const _hoisted_15 = {
  class: "btn col-10 col-lg-5 p-3 my-2",
  href: "https://www.inegi.org.mx/programas/encuci/2020/",
  target: "_blank"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Descargar ENCUCI 2020", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", _hoisted_8, [
                _createVNode(_component_DownloadIcon, { class: "icon me-2" }),
                _hoisted_9
              ]),
              _createElementVNode("a", _hoisted_10, [
                _createVNode(_component_DownloadIcon, { class: "icon me-2" }),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("a", {
                class: "btn col-10 col-lg-5 p-3 my-2",
                href: _ctx.informePaisVariables['Enlace Informe País 2020'],
                target: "_blank"
              }, [
                _createVNode(_component_DownloadIcon, { class: "icon me-2" }),
                _hoisted_14
              ], 8, _hoisted_13),
              _createElementVNode("a", _hoisted_15, [
                _createVNode(_component_DownloadIcon, { class: "icon me-2" }),
                _hoisted_16
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}